import { useResourceList__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResourceList';
import React, { useCallback, useMemo } from 'react';

import { mapActivitiesToDateGroups } from './utils/mapActivitiesToDateGroups';
import { ActivityGroup } from './prefabs/ActivityGroup';
import { LoadMoreBumper } from '@cube3/ui/src/utils/withLazyLoad';
import { useCurrentWorkspace } from '@cube3/state/src/redux/components/Administration/withCurrentWorkspace';
import { useModalActions } from '../Modals/modalActions';
import { EmptyNotificationItem } from '@cube3/cubicle/src/core/atoms/Activity/EmptyNotificationItem';
import { VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';

interface Props {
  onClickLink(): void;
}
const loaders = [1, 2, 3];
export const WorkspaceActivity = (props: Props) => {
  const { onClickLink } = props;
  const [pages, setPages] = React.useState([1]);
  const pagesize = 20;
  const pageParams = React.useRef({ page: { size: pagesize } });

  const loadMore = React.useCallback(() => {
    setPages([...pages, pages.length + 1]);
  }, [pages, setPages]);

  const [workspaceId] = useCurrentWorkspace();

  const activities = useResourceList__ALPHA({
    resourceType: 'workspace',
    resourceId: workspaceId,
    edgeType: 'activity',
    edgeLabel: 'activities',
    strategy: 'fetch-on-mount',
    params: pageParams.current,
    pages
  });


  const showLoadMore =
    !activities.loading &&
    activities.pageCounts &&
    pages.length < activities.pageCounts.pageCount;

  const { closeAllModals } = useModalActions();

  const closeFeed = useCallback(() => {
    onClickLink();
    closeAllModals();
  }, [closeAllModals, onClickLink]);

  return (
    <>
      {!activities.resources && (
        <VBox gap={8} align="center">
          {loaders.map((l) => (
            <EmptyNotificationItem
              key={l}
              focusedState={l === 1}
              variant={activities.loading ? 'indeterminate' : 'determinate'}
              animationVariant="fillIn"
            />
          ))}
          <Typography colorVariant="03">Your inbox is empty</Typography>
        </VBox>
      )}
      {activities.resources && (
        <ActivityGroup
          activities={activities.resources}
          onClickLink={closeFeed}
          variant="workspace"
        />
      )}
      {/* <ActivityGroup
        title={'This week'}
        activities={mappedActivies.thisWeekArray}
        onClickLink={closeFeed}
      />

      <ActivityGroup
        title={'Last week'}
        activities={mappedActivies.lastWeekArray}
        onClickLink={closeFeed}
      />

      <ActivityGroup
        title={'This month'}
        activities={mappedActivies.thisMonthArray}
        onClickLink={closeFeed}
      />

      <ActivityGroup
        title={'Last month'}
        activities={mappedActivies.lastMonthArray}
        onClickLink={closeFeed}
      />

      <ActivityGroup
        title={'Earlier this year'}
        activities={mappedActivies.earlierThisYearArray}
        onClickLink={closeFeed}
      />

      <ActivityGroup
        title={'Last year'}
        activities={mappedActivies.lastYearArray}
        onClickLink={closeFeed}
      />

      <ActivityGroup
        title={'A long time ago'}
        activities={mappedActivies.longAgoArray}
        onClickLink={closeFeed}
      /> */}
      {showLoadMore && (
        <LoadMoreBumper
          once={false}
          callback={(visible) => (visible ? loadMore() : undefined)}
        />
      )}
    </>
  );
};
